<template>
  <Carousel
    :card-classes="tw`w-256`"
    :region-label="i18n(translations.regionLabel)"
  >
    <div
      v-for="(product, index) in products"
      :key="product.title"
      :ref="
        setupViewportTrackingProduct(product, {
          list: 'ai_shopping_assistant',
          source: 'ai_shopping_assistant_recommendation',
          position: index + 1,
        })
      "
      class="relative h-full hover:z-[1] focus-within:z-[1]"
    >
      <ProductCardCarouselCard
        :index
        :product
        :product-granularity
        :tracking="{
          list: 'ai_shopping_assistant',
          source: 'ai_shopping_assistant_recommendation',
        }"
        v-on="addToCartListener ? { addToCart: handleAddToCart(product) } : {}"
        @link-click="emits('link-click', { product })"
      />
      <slot :index name="post-card" :product />
    </div>
  </Carousel>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed, getCurrentInstance } from 'vue'

import ProductCardCarouselCard from '@backmarket/nuxt-layer-recommendation/ProductCardCarouselCard.vue'
import type { Product } from '@backmarket/nuxt-layer-recommendation/models/product'
import { useImpressionTracking } from '@backmarket/nuxt-layer-recommendation/useProductTracking'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { tw } from '@ds/utils/tailwind.js'

import Carousel from '../Carousel/Carousel.vue'

import translations from './ProductCardCarousel.translations'

defineProps<{ products: Product[] }>()

const i18n = useI18n()

const emits = defineEmits<{
  (e: 'add-to-cart', data: { status: string; product: Product }): void
  (e: 'link-click', data: { product: Product }): void
}>()

const config = useRuntimeConfig()

// FIXME Backdoor to switch product granularity to "parent" in case the Add to cart button needs to be hidden.
const productGranularity = computed(() =>
  config.public.FF_SHOPPING_ASSISTANT_PRODUCT_GRANULARITY_PARENT
    ? 'parent'
    : 'backbox',
)

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

function handleAddToCart(product: Product) {
  return ({ status }: { status: string }) => {
    emits('add-to-cart', { status, product })
  }
}

const { setupViewportTrackingProduct } = useImpressionTracking(1000)
</script>
